import { render } from "./room-3.vue?vue&type=template&id=5a77041a&scoped=true"
import script from "./room-3.vue?vue&type=script&lang=js"
export * from "./room-3.vue?vue&type=script&lang=js"

import "./room-3.vue?vue&type=style&index=0&id=5a77041a&lang=scss&scoped=true"

import exportComponent from "/Users/dima/Projects/OrangeStatic/rise-homestories/public/themes/rise-theme/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5a77041a"]])

export default __exports__